import React from 'react';

import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { colorsSelector } from '@redux/colorPalette/selectors';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { COLOR_THEME } from 'constants/colorThemes';

import { StyledButton, IconContainer, TextContainer } from './Button.style';

interface Props {
  translationId: string;
  onClick?: () => void;
  Icon?:
  | OverridableComponent<SvgIconTypeMap<object, 'svg'>>
  | React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  className?: string;
  id?: string;
  light?: boolean;
  error?: boolean;
  largeFont?: boolean;
  colorTheme?: COLOR_THEME;
}

const Button: React.FC<Props> = ({
  Icon,
  onClick,
  translationId,
  className,
  id,
  light = false,
  error = false,
  largeFont = false,
  colorTheme = COLOR_THEME.STAFF,
}) => {
  const colors = useSelector(colorsSelector);
  return (
    <StyledButton
      {...{ onClick, className, id, light, error, colorTheme, colors }}
    >
      {Icon && (
        <IconContainer>
          <Icon fontSize='inherit' />
        </IconContainer>
      )}
      <TextContainer largeFont={largeFont}>
        <FormattedMessage id={translationId} />
      </TextContainer>
    </StyledButton>
  );
};

export default Button;
